/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Visiondesc1Inputs */

const zh_about_visiondesc1 = /** @type {(inputs: About_Visiondesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们正在构建一个教育者和学习者共同受益的平台。在这里，创造力不受技术限制，学习不再枯燥乏味，AI 成为每位老师最得力的助手，每位学生最耐心的导师。`)
};

const en_about_visiondesc1 = /** @type {(inputs: About_Visiondesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are building a platform where educators and learners thrive together. Where creativity is not limited by technology, learning is never dull, AI becomes every teacher's most capable assistant, and every student's most patient mentor.`)
};

const es_about_visiondesc1 = /** @type {(inputs: About_Visiondesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos construyendo una plataforma donde educadores y estudiantes prosperan juntos. Donde la creatividad no está limitada por la tecnología, el aprendizaje nunca es aburrido, la IA se convierte en el asistente más capaz de cada profesor y el tutor más paciente de cada estudiante.`)
};

/**
* | output |
* | --- |
* | "We are building a platform where educators and learners thrive together. Where creativity is not limited by technology, learning is never dull, AI becomes ev..." |
*
* @param {About_Visiondesc1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_visiondesc1 = /** @type {((inputs?: About_Visiondesc1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Visiondesc1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_visiondesc1(inputs)
	if (locale === "en") return en_about_visiondesc1(inputs)
	return es_about_visiondesc1(inputs)
});
export { about_visiondesc1 as "about_visionDesc" }